
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class RelatedQuestionsBar extends Vue {
  @Prop({ default: () => [] }) public suggestions!: any[];
  @Prop({ default: 3 }) public maxDisplay!: number;
  @Prop({ required: true }) public parentQuestionId!: string;

  // Only show the configured number of suggestions
  get displayedSuggestions(): any[] {
    return this.suggestions.slice(0, this.maxDisplay);
  }

  public onSuggestionClick(suggestion: any): void {
    this.$emit('suggestion-selected', {
      suggestion,
      question: suggestion.question,
      parentQuestionId: this.parentQuestionId,
    });
  }
}
